import React from 'react';
import { Col } from 'react-flexbox-grid';
import Subheader from 'material-ui/Subheader';
import Paper from 'material-ui/Paper';

import { FormattedMessage } from 'react-intl';

const styles = {
  apple: {
    borderRadius: '13px',
    display: 'inline-block',
    overflow: 'hidden',
  },
  android: {
    display: 'inline-block',
    overflow: 'hidden',
  },
  subheader: {
    fontSize: 20,
    fontWeight: 300,
    fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
    paddingLeft: 8,
    paddingRight: 8,
  },
  container: {
    padding: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    flexWrap: 'wrap',
  },
  description: {
    fontSize: 16,
    fontWeight: 300,
    fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
    padding: 8,
    marginTop: 0,
    marginBottom: 16,
    textAlign: 'center',
  },
  paper: {
    padding: 16,
    margin: 8,
  },
};

/* eslint jsx-a11y/anchor-has-content: 0 */
const AppLinks = () => (
  <Col xs={12} sm={8} smOffset={2} md={6} mdOffset={3}>
    <Subheader style={styles.subheader}><FormattedMessage id="appLinks.title" /></Subheader>
    <Paper style={styles.paper}>
      <p style={styles.description}>
        <FormattedMessage id="appLinks.message" />
      </p>
      <div style={styles.container}>
        <a
          href="https://apps.apple.com/us/app/kjarni/id1540767408?itsct=apps_box_badge&amp;itscg=30200"
          style={styles.apple}
        >
          <img
            src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1606003200"
            alt="Download on the App Store"
            style={{
              borderRadius: 13, width: 166, height: 55,
            }}
          />
        </a>

        <a
          href="https://play.google.com/store/apps/details?id=is.origo.kjarni.android&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
          style={styles.android}
        >
          <img
            alt="Get it on Google Play"
            src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
            style={{ width: 195, height: 80, }}
          />
        </a>

      </div>
    </Paper>
  </Col>
);

export default AppLinks;



// WEBPACK FOOTER //
// ./src/components/AppLinks.js